<template>
  <el-form :model="form" :rules="rules" ref="form" @submit.prevent.native="onSubmit">
    <el-form-item label="Distributor name" prop="name">
      <el-input v-model="form.name"></el-input>
    </el-form-item>
    <el-row :gutter="15">
      <el-col :xs="24" :sm="12">
        <el-form-item label="Street">
          <el-input v-model="form.address.street"></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12">
        <el-form-item label="Building">
          <el-input v-model="form.address.building"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="15">
      <el-col :xs="24" :sm="12">
        <el-form-item label="City or town">
          <el-input v-model="form.address.city"></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12">
        <el-form-item label="Postal code">
          <el-input v-model="form.address.postal_code"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="15">
      <el-col :xs="24" :sm="12">
        <el-form-item label="State">
          <el-input v-model="form.address.state"></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12">
        <el-form-item label="Country">
          <app-countries v-model="form.address.country_id" :disabled="true" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item label="Contact email address" prop="email">
      <el-input v-model="form.email"></el-input>
    </el-form-item>
    <el-form-item label="Contact phone">
      <el-input v-model="form.phone"></el-input>
    </el-form-item>
    <el-button native-type="submit" type="primary" :loading="loading">Save</el-button>
  </el-form>
</template>

<script>
import AppCountries from '@/components/App/AppCountries'

export default {
  components: {
    AppCountries,
  },

  props: {
    distributor: Object,
  },

  data() {
    return {
      loading: false,
      form: this.distributor,
      rules: {
        'email': [
          { type: 'email', message: 'This email address does not appear valid.', trigger: 'blur' },
        ],
        'name': [
          { required: true, message: 'Enter the distributor name.', trigger: 'blur' },
        ],
      },
    }
  },

  methods: {
    async onSubmit() {
      this.$refs['form'].validate(async valid => {
        if (!valid) {
          return false
        }

        this.loading = true

        try {
          var { data } = await this.$http.put(`/distributors/${ this.distributor.id }`, {
            building: this.form.address.building,
            city: this.form.address.city,
            country_id: this.distributor.address.country_id, // Cannot be changed.
            email: this.form.email,
            name: this.form.name,
            postal_code: this.form.address.postal_code,
            phone: this.form.phone,
            state: this.form.address.state,
            street: this.form.address.street,
          })
        } catch(err) {
          this.$message.error(err.response.data.message)
          return false
        } finally {
          this.loading = false
        }

        this.$message.success(data.message)
      })
    },
  },
}
</script>
